var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMeetinNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4216 9C21.952 9 22.4607 9.21071 22.8358 9.58579L28.4142 15.1642C28.7893 15.5393 29 16.048 29 16.5784V29.25C29 29.8467 28.7629 30.419 28.341 30.841C27.919 31.2629 27.3467 31.5 26.75 31.5H13.25C12.6533 31.5 12.081 31.2629 11.659 30.841C11.2371 30.419 11 29.8467 11 29.25V11.25C11 10.6533 11.2371 10.081 11.659 9.65901C12.081 9.23705 12.6533 9 13.25 9H21.4216ZM21.125 16.375C21.125 16.6511 21.3489 16.875 21.625 16.875H25.5429C25.9883 16.875 26.2114 16.3364 25.8964 16.0214L21.9786 12.1036C21.6636 11.7886 21.125 12.0117 21.125 12.4571V16.375ZM13 22.5004C13 21.9481 13.4477 21.5004 14 21.5004H25.25C25.8023 21.5004 26.25 21.9481 26.25 22.5004C26.25 23.0527 25.8023 23.5004 25.25 23.5004H14C13.4477 23.5004 13 23.0527 13 22.5004ZM13 25.5001C13 24.9478 13.4477 24.5001 14 24.5001H20.75C21.3023 24.5001 21.75 24.9478 21.75 25.5001C21.75 26.0524 21.3023 26.5001 20.75 26.5001H14C13.4477 26.5001 13 26.0524 13 25.5001Z",
    fill: "#FFCA72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMeetinNotes);
export default __webpack_public_path__ + "static/media/IconMeetinNotes.f82a4fcc.svg";
export { ForwardRef as ReactComponent };